import { Module } from 'vuex';
import 'firebase/firestore';
import i18n from '@/plugins/vueI18n';
import moment from 'moment'
import { facilityLanguageIsoToShortLocale } from '@/utils/localization';
import Vue from "vue";
import vuetify from '../../plugins/vuetify'
import Vuetify from 'vuetify';
import { defaultFacilityValues } from '@/consts/defaultFacilityValues';

const localizationModule: Module<any, any> = {
  namespaced: false,
  state: {
    facilityLocale: defaultFacilityValues.locale,
    shortLocale: defaultFacilityValues.shortLocale,
  },

  mutations: {
    setFacilityLocale(state: any, payload: any) {
      state.facilityLocale = payload;
    },
    setShortLocale(state: any, payload: any) {
      state.shortLocale = payload;
    }
  },

  actions: {
    async translate({ commit }, { locale, force }) {

      if (!locale) {
        locale = defaultFacilityValues.locale
      }

      if (i18n.locale !== locale && !!force) return

      //translate momentjs dates
      const shortLocale = facilityLanguageIsoToShortLocale(locale)
      moment.locale(shortLocale)

      //translate vuetify
      vuetify.framework.lang.current = shortLocale;
      Vue.use(Vuetify);

      //translate the app
      i18n.locale = locale;

      commit("setFacilityLocale", locale);
      commit("setShortLocale", shortLocale);
    },

  }

};
export default localizationModule;